import { Factory } from 'fishery';
import { Terminal } from '@trukt/types/Terminal';
import { NonNullableKeys } from '@trukt/types/NonNullableKeys';
import { contactFactory } from './contactFactory';
import { userFactory } from './userFactory';

export const terminalFactory = Factory.define<NonNullableKeys<Terminal>>(({ sequence }) => ({
  guid: sequence.toString(),
  name: 'Fisher and Sons',
  street1: 'Gutkowski Fork',
  street2: 'Apt. 138',
  state: 'NV',
  city: 'Port Jalenport',
  country: 'Swaziland',
  zipCode: '97697',
  locationType: 'warehouse',
  latitude: 24.32969,
  longitude: -84.62091,
  notes: 'Must call at least 48 hours ahead to schedule pick up',
  dateCreated: '',
  dateUpdated: '',
  dateResolved: '',
  updatedBy: userFactory.build(),
  createdBy: userFactory.build(),
  isActive: true,
  primaryContact: contactFactory.build(),
  alternativeContact: contactFactory.build(),
}));
